module.exports = __webpack_public_path__ + "static/staff1-282780d47ed10f26cd1278385e72daec.png";